var _circle, _circle2, _circle3, _circle4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "url(#paint0_linear_680_13463)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_680_13463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "url(#paint1_linear_680_13463)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_680_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17383 13.3808L9.2266 9.21589V14.9732L11.4521 7.66309L18.2371 2.92969L15.036 15.0616L19.0459 20.9995H12.3187L9.2266 16.423V20.9995H3.17383V13.3808Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_680_13463",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F4FE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#3848DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2838CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_680_13463",
    x1: 10.5,
    y1: 0,
    x2: 9.04487,
    y2: 36.4832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3244E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B278F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusLogo);
export default __webpack_public_path__ + "static/media/bonus-logo.7b79b1c544867bd0a69acaaed6fdc8b2.svg";
export { ForwardRef as ReactComponent };